<table mat-table [dataSource]="dataSource" matSort matSortActive="date" matSortDirection="desc">
  <!-- Id Column -->
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Request ID</th>
    <td mat-cell *matCellDef="let element">{{ element.id }}</td>
  </ng-container>

  <!-- Amount Column -->
  <ng-container matColumnDef="amount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
    <td mat-cell *matCellDef="let element">{{ element.amount | currency }}</td>
  </ng-container>

  <!-- Payment Method Column -->
  <!-- <ng-container matColumnDef="payment_method">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Method</th>
    <td mat-cell *matCellDef="let element">{{ getPaymentMethodLabel(element.payment_method) }}</td>
  </ng-container> -->

  <!-- Status Column -->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
    <td mat-cell *matCellDef="let element">{{ element.status }}</td>
  </ng-container>

  <!-- Date Column -->
  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
    <td mat-cell *matCellDef="let element">{{ element.date | date: 'medium' }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
